import { LitElement } from 'lit';
import { html, css } from 'lit';
import { Image } from '../Image/Image';
import { Text } from '../Text/Text';
import { generateProfileImageByInitials } from '../../../lib/helpers';
import { WEB_CONTENT } from '../../../constants/content';
import { drawerDialogService } from '../Dialog-Drawer/dialog-drawer';
import {getGroupcastUrlQuery} from '../../../lib/helpers';

class ContactTile extends LitElement {
  static properties = {
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    padding: { type: String },
    height: { type: String },
    width: { type: String },
    time: { type: String },
    alignSelf: { type: String },
    isRead: { type: Boolean },
    isPopupOpen: { type: Boolean },
    fontFamily: { type: String },
    isDelivered: { type: String },
    textColor: { type: String },
    imageSrc: {type: String},
    contactName: {type: String},
    conversationId:{type: String},
    isChecked: {type: Boolean},
    isCheckBox: { type: Boolean },
    userId: {type: String},
    suffix: { type: String },
    suffixColor: { type: String },
    suffixBgColor: { type: String },
    gap:{type: String},
    isAdmin: { type: Boolean },
    showActions: { type: Boolean },
    actionsPopupOpen: { type: Boolean },
    openOwnProfile: { type: Boolean },
    openProfile: {type: Function},
    isGroupcast: {type: Boolean}
  };

  constructor() {
    super();
    this.isChecked = false;
    this.isCheckBox = true;
    this.gap = "10px";
    this._handleClickOutside = this._handleClickOutside.bind(this);
    this.isGroupcast = false;
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', this._handleClickOutside);
    document.addEventListener('admin-status-changed', this._handleAdminStatusChange.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this._handleClickOutside);
    document.removeEventListener('admin-status-changed', this._handleAdminStatusChange);
  }

  _handleClickOutside(event) {
    const actionsPopup = this.shadowRoot.querySelector('.actions-popup');
    const kebabMenu = this.shadowRoot.querySelector('.kebab-menu');
    
    if (this.actionsPopupOpen && 
        actionsPopup && 
        kebabMenu && 
        !actionsPopup.contains(event.target) && 
        !kebabMenu.contains(event.target)) {
      this.actionsPopupOpen = false;
    }
  }

  _handleAdminStatusChange(event) {
    if (event.detail.userId === this.userId) {
      this.isAdmin = event.detail.isAdmin;
      if (this.isAdmin) {
        this.suffix = 'Admin';
        this.suffixBgColor = 'var(--bg-secondary-color)';
        this.suffixColor = 'var(--text-primary-color)';
      } else {
        this.suffix = '';
        this.suffixBgColor = '';
        this.suffixColor = '';
      }
      
      this.requestUpdate();
    }
  }

  static styles = css`
    .contact-tile-container {
       display: flex;
       align-items: center;
       gap: 20px;
       background-color: var(--bg-color);
       transition: background-color 0.3s ease;
       position: relative;
    }

    .contact-tile-container:hover {
      background-color: var(--bg-primary-light);
      cursor: pointer;
    }

    .contact-tile-select {
      input {
        width: 15px;
        height: 15px;
        accent-color: #99e5d9;
        cursor: pointer;
      }
    }

    .contact-info {
      display: flex;
      align-items: center;
    }

    .kebab-menu {
      cursor: pointer;
      margin-left: auto;
      padding: 5px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .kebab-menu:hover {
      background: var(--bg-primary-light);
      border-radius: 50%;
    }

    .actions-popup {
      position: absolute;
      right: 30px;
      padding: 10px;
      background: var(--bg-primary-color);
      bottom: 40px;
      color: var(--text-primary-color);
      border-radius: 10px;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    }


    .actions-popup-content button {
      border:none;
      cursor: pointer;
      background: transparent;
      color: var(--text-primary-color);
      font-size: var(--text-primary-size);
      padding: 10px;
      width: 100%;
    }

    .actions-popup-content button:hover {
      background: var(--bg-primary-light);
    }

    .suffix-container {
     padding: 3px 10px; 
     border-radius: 12px;
     font-size: 14px;
     position: absolute;
     top: 30%;
     right: 45px;
    }

    
    .popup-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    }

     .popup-content {
      background: var(--bg-primary-color);
      padding: 14px;
      border-radius: 8px;
      width: 28%;
      max-height: 80vh;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      text-align: center;
    }

    .popup-buttons {
      display: flex;
      margin-top: 10px;
      gap: 10px;
    }

    .popup-buttons button {
      padding: 10px;
      outline: 0;
      border: none;
      cursor: pointer;
      flex: 1;
      border-radius: 25px;
    }

    .popup-buttons button:first-child {
      border: 1px solid var(--text-primary-color);
      color: var(--text-primary-color);
      background: transparent;
    }

    .popup-buttons button:first-child:hover {
      background: var(--text-primary-color);
      color: var(--bg-primary-color);
    }

    .popup-buttons button:last-child {
      background: var(--bg-secondary-color);
      color: var(--text-primary-color);
    }
    
  `;

  render() {
    const bgColor = this.bgColor;
    const bgColorLight = this.lightenColor(this.bgColor, 30);

    return html`
      <style>
        :host {
          --bg-color: ${bgColor};
          --bg-color-light: ${bgColorLight};
        }
      </style>
      <div class="contact-tile-container" 
           style="padding: ${this.padding}; border-width: ${this.borderWidth};
                  border-color: ${this.borderColor}; border-style: solid;
                  width: ${this.width}; height: ${this.height}; color: ${this.textColor}; border-radius: ${this.borderRadius }">
     
           ${this.suffix ? html`<div class="suffix-container" style=" background-color: ${this.suffixBgColor}; color: ${this.suffixColor};  ">${this.suffix}</div>` : ''}

                  ${this.isCheckBox ? html`
          <div class="contact-tile-select">
            <input type="checkbox" @change=${this.handleCheckboxChange} ?checked=${this.isChecked} />
          </div>
        ` : ''}
        <div @click=${this._handleNameClick} class="contact-info" style="gap: ${this.gap}">
          ${Image({
            src: this.imageSrc,
            alt: 'chat image',
            borderRadius: '50%',
            height: '40px',
            width: '40px',
            objectFit:  'cover',
            placeholderImage: generateProfileImageByInitials(this.contactName)
          })}
          <div  style="cursor: pointer;">
            ${Text({
              content: this.contactName,
              color: this.textColor,
              maxWidth: '100%',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap'
            })}
          </div>
        </div>

        ${this.actionsPopupOpen ? html`
          <div class="actions-popup">
            <div class="actions-popup-content">
            ${!this.isGroupcast ? html`
             ${this.isAdmin ? html`
                <button @click=${ ()=> this.handleConfirmation('remove-admin',WEB_CONTENT.CHAT.GROUP_INFO.GROUP_MEMBERS.REMOVE_ADMIN)}>${WEB_CONTENT.CHAT.GROUP_INFO.GROUP_MEMBERS.REMOVE_ADMIN}</button>
              ` : html`
                <button @click=${()=> this.handleConfirmation('make-admin',WEB_CONTENT.CHAT.GROUP_INFO.GROUP_MEMBERS.MAKE_ADMIN)}>${WEB_CONTENT.CHAT.GROUP_INFO.GROUP_MEMBERS.MAKE_ADMIN}</button>
              `}
            ` : null}
              
              <button @click=${()=> this.handleConfirmation('remove-memeber',WEB_CONTENT.CHAT.GROUP_INFO.GROUP_MEMBERS.REMOVE_MEMBER)}>${WEB_CONTENT.CHAT.GROUP_INFO.GROUP_MEMBERS.REMOVE + ' ' + this.contactName}</button>
            </div>
          </div>
        ` : ''}
        ${this.showActions ? html`
          <div class="kebab-menu" @click=${this._handleKebabClick} style="background-color: ${this.actionsPopupOpen ? 'var(--bg-primary-light)' : 'transparent'};">
           <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)"><path d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"/></svg>
          </div>
        ` : ''}

      </div>
    `;
  }

  lightenColor(color, percent) {
    const num = parseInt(color.replace("#", ""), 16),
          amt = Math.round(2.55 * percent),
          R = (num >> 16) + amt,
          G = (num >> 8 & 0x00FF) + amt,
          B = (num & 0x0000FF) + amt;
    return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
  }

  handleCheckboxChange(event) {
    this.isChecked = event.target.checked;
    this.dispatchEvent(new CustomEvent('contact-selected', {
      detail: {
        contactName: this.contactName,
        isChecked: this.isChecked,
        contactConversationId: this.conversationId,
        userId: this.userId
      },
      bubbles: true,
      composed: true,
    }));
  }

  _handleKebabClick(e) {
    e.stopPropagation(); 
    this.actionsPopupOpen = !this.actionsPopupOpen;
  }

  _handleRemoveAdmin() {
    this.dispatchEvent(new CustomEvent('remove-admin-clicked', {
      detail: {
        username: this.contactName,
        userId: this.userId
      },
      bubbles: true,
      composed: true
    }));
  }

  _handleMakeAdmin() {
    this.dispatchEvent(new CustomEvent('make-admin-clicked', {
      detail: {
        username: this.contactName,
        userId: this.userId
      },
      bubbles: true,
      composed: true
    }));
  }

  _handleRemoveMember() {
    const {isGroupcast, groupcastId} = getGroupcastUrlQuery()
    this.dispatchEvent(new CustomEvent('remove-member-clicked', {
      detail: {
        username: this.contactName,
        userId: this.userId,
        conversationId: isGroupcast ? groupcastId : this.conversationId,
        isGroupcast: this.isGroupcast,
        imageSrc: this.imageSrc
      },
      bubbles: true,
      composed: true
    }));
  }



handleConfirmation(action,title) {
  drawerDialogService.openDialog('confirm-dialog', { 
    title: `${title}`, 
    description: this.handleDescription(action),
    handleConfirm:() => this.confirmAction(action)
  });
this.actionsPopupOpen = false;
}

handleDescription(action) {
  switch (action){
    case 'remove-memeber':
      return `Are you sure you want to remove ${this.contactName} as member?`
    case'make-admin':
    return `Are you sure you want to make ${this.contactName} admin ?`
    case'remove-admin':
    return `Are you sure you want to remove ${this.contactName} as admin ?`
  }
}

confirmAction(action) {
  switch (action) {
    case 'remove-memeber':
      this._handleRemoveMember();
      break;
    case 'make-admin':
      this._handleMakeAdmin();
      break;
    case 'remove-admin':
      this._handleRemoveAdmin();
      break;
  }
}

  _handleNameClick(e) {
    e.stopPropagation();
    this.dispatchEvent(new CustomEvent('name-clicked', {
      detail: {
        userId: this.userId,
        userName: this.contactName
      },
      bubbles: true,
      composed: true
    }));
  }
}

customElements.define('contact-tile', ContactTile);
